/* unplugin-vue-components disabled */import { render } from "./BarcodePopup.vue?vue&type=template&id=0bc01d62"
import script from "./BarcodePopup.vue?vue&type=script&lang=js"
export * from "./BarcodePopup.vue?vue&type=script&lang=js"

import "./BarcodePopup.vue?vue&type=style&index=0&id=0bc01d62&lang=scss"
script.render = render

export default script